import { VatNatureType } from "../vat-nature-type";

export enum InvoiceItemType {
  MEDICAL_SERVICE = "medical-service",
  DRUG_ASSIGNMENT = "drug-assignment",
  PARAPHARMACEUTICAL = "parapharmaceutical",
  PRODUCT_SALE = "product-sale",
  ADVANCE_PAYMENT = "advance-payment"
}

export enum InvoiceItemUnit {
  PIECE = "piece",
  PACKAGE = "package"
}

export interface InvoiceItem {
  id: string;
  createdAt: Date;
  createdBy?: {
    id: string;
    name: string;
  };

  type: InvoiceItemType;
  number: string;
  name: string;
  description?: string;
  quantity: number;
  unitPrice: number;
  unit?: InvoiceItemUnit;
  discount?: number;
  vat: number;
  vatNature?: VatNatureType | null;

  rateable: number; // Imponibile di riga (al netto della cassa)
  enpavAmount?: number; // Ammontare della cassa Enpav
  vatTaxAmount: number; // Ammontare della tassa IVA
  withholdingTaxAmount?: number; // Ammontare della ritenuta d'acconto
  taxedTotal: number; // Totale tassato
  adjustment?: number; // Aggiustamento sul totale
  adjustedTotal: number; // Totale corretto (Totale da pagare)

  rateTable?: {
    id: string;
    name: string;
  };

  ticket?: {
    id: string;
    number: string;
  };

  executedAt?: Date;
  executedBy?: Array<{
    id: string;
    name: string;
    percentage: number;
  }>;

  bookItemId?: string;
  rateTableItemId: string;

  patientId?: string;

  // extended
  patientName?: string;
  patientMicrochip?: string;

  origin?: {
    id: string;
    number: string;
    type: "quote" | "invoice";
  };

  unloadingId?: string;
}
